import api from "../../../services/api";

export const fetchWholesaleMultiChannel = async (period: number) => {
  const response = await api.get("/api/wholesale/managerial/multi_channel", {
    params: { period },
  });
  return response.data;
};
